import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

/**
 * Hook to check if the current user can manage API keys.
 * "Manage" means: create new API keys, edit API key details, or delete API keys.
 * This does NOT control role binding management - SpaceAdmins can manage role bindings.
 *
 * @returns {boolean} true if user is a root admin, false for SpaceAdmins and other users
 */
const useCanManageApiKeys = (): boolean => {
  const { viewer } = useTypedContext(AccountContext);
  return viewer.admin;
};

export default useCanManageApiKeys;
